import { useState } from "react";
import { ImageDown, Loader2 } from "lucide-react";
import { downloadNodePng } from "@/lib/download";

export function ChartDownloadButton({ targetRef, filename, testId }) {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    if (!targetRef.current) return;
    setBusy(true);
    await downloadNodePng(targetRef.current, filename);
    setBusy(false);
  };
  return (
    <button type="button" onClick={click} disabled={busy} data-export-ignore="true" data-testid={testId}
      title="Download chart as PNG" aria-label="Download chart as PNG"
      className="inline-flex items-center gap-1.5 rounded-lg border border-border bg-card px-2.5 py-1.5 text-xs font-semibold text-foreground/80 hover:bg-secondary transition-colors disabled:opacity-60">
      {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <ImageDown className="h-3.5 w-3.5" />} PNG
    </button>
  );
}
